import styled, { createGlobalStyle } from 'styled-components';
import {
	MAX_MD,
	MD_LG_BUTTON_3,
	MD_LG_PARA_2,
} from '@silverrailtech/srtlibrary';
import { textPrimary1, textPrimary3 } from '../../../colors';

export const DatePickerGlobalStyle = createGlobalStyle`
	.ouigo-refunds-date-picker .react-datepicker-popper {
		max-width: calc(100vw - 32px);
		width: 374px !important;
	}

	.ouigo-refunds-date-picker .react-datepicker {
		width: 100% !important;
	}

	.ouigo-refunds-date-picker .react-datepicker-wrapper,
	.ouigo-refunds-date-picker .react-datepicker__input-container {
		width: 100%;
	}

	.ouigo-refunds-date-picker input {
		box-sizing: border-box;
		width: 100%;
	}
`;

export const ToolbarLabel = styled.span`
	${MD_LG_PARA_2}
	color: ${textPrimary3};
	margin-bottom: 0;
	white-space: nowrap;
`;

export const ResultCount = styled.span`
	${MD_LG_BUTTON_3}
	background-color: transparent;
	border: 0;
	color: ${textPrimary1};
	padding: 6px;
	white-space: nowrap;
`;

export const ToolbarWrapper = styled.div`
	align-items: flex-end;
	display: flex;
	gap: 8px;
	margin-left: auto;

	@media screen and (max-width: ${MAX_MD}) {
		align-items: stretch;
		flex-wrap: wrap;
		margin-left: 0;
		width: 100%;
	}
`;

export const DateRangeWrapper = styled.div`
	display: flex;
	width: 381px;

	@media screen and (max-width: ${MAX_MD}) {
		flex: 1 1 100%;
		max-width: 100%;
		width: 100%;
	}
`;

export const ToolbarActions = styled.div`
	align-items: center;
	align-self: flex-end;
	display: flex;
	gap: 8px;
	height: 40px;

	@media screen and (max-width: ${MAX_MD}) {
		justify-content: flex-end;
		width: 100%;
	}
`;

export const getToolbarActionsStyle = (height) => ({
	alignItems: 'center',
	alignSelf: 'flex-end',
	display: 'flex',
	gap: 8,
	height,
});

export default {
	field: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minWidth: 0,
	},
	label: {
		color: textPrimary3,
		marginBottom: 0,
		whiteSpace: 'nowrap',
	},
	actions: getToolbarActionsStyle(40),
};
